import React from 'react';
import { makeStyles } from '@material-ui/styles';
import {
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  TextField,
  Typography
} from '@material-ui/core';

const useStyles = makeStyles(theme => ({
  root: {},
  mainActions: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start'
  },
  notice: {
    marginTop: theme.spacing(1),
    marginBottom: theme.spacing(1)
  },
  deleteButton: {
    color: theme.palette.common.white,
    backgroundColor: theme.palette.error.main,
    '&:hover': {
      backgroundColor: theme.palette.error.dark
    }
  },
  buttonIcon: {
    marginRight: theme.spacing(1)
  },
  center: {
    display: 'flex',
    alignItems: 'baseline'
  }
}));

function DeleteModal({
  open,
  onClose,
  objectName,
  title,
  subtitle,
  warningText,
  onDelete,
  disabled,
  setDisabled,
  error
}) {
  const classes = useStyles();

  const onChange = event => {
    if (event.target.value === objectName.toLowerCase()) {
      setDisabled(false);
    } else {
      setDisabled(true);
    }
  };

  return (
    <Dialog
      open={open}
      onClose={() => {
        onClose();
      }}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
    >
      <DialogTitle id="alert-dialog-title">{title}</DialogTitle>
      <DialogContent>
        <DialogContentText id="alert-dialog-description">
          {subtitle}
          <br />
          <strong>{warningText}</strong>
        </DialogContentText>
        <TextField
          fullWidth
          variant="outlined"
          className={classes.notice}
          placeholder={`Type '${objectName.toLowerCase()}' to confirm`}
          onChange={onChange}
        />
        <Typography variant={'overline'} color="error">
          {error}
        </Typography>
      </DialogContent>
      <DialogActions className={classes.center}>
        <Button
          onClick={() => {
            onClose();
          }}
        >
          cancel
        </Button>
        <Button
          onClick={onDelete}
          className={classes.deleteButton}
          disabled={disabled}
        >
          Delete
        </Button>
      </DialogActions>
    </Dialog>
  );
}

export default DeleteModal;
